import { useEffect, useState } from "react";
import { useApiClient } from "../../../hooks/useApiClient";
import { getEmployeesMinimalExcludeCurrentAndTeamLeaders } from "../../../services/employeesService";
import { IEmployeesResponse } from "../Interfaces/IEmployeeInterface";

export function useEmployeesMinimal() {
  const { call, ready } = useApiClient();
  const [employeesMinimal, setEmployeesMinimal] = useState<IEmployeesResponse | null>(null);
  const [loadingEmployeesMinimal, setLoadingEmployeesMinimal] = useState(true);
  const [errorEmployeesMinimal, setErrorEmployeesMinimal] = useState<Error | null>(null);

  useEffect(() => {
    if (!ready) return;

    (async () => {
      setLoadingEmployeesMinimal(true);
      setErrorEmployeesMinimal(null);
      try {
        const data = await call(getEmployeesMinimalExcludeCurrentAndTeamLeaders);
        setEmployeesMinimal(data);
      } catch (err) {
        setErrorEmployeesMinimal(err as Error);
      } finally {
        setLoadingEmployeesMinimal(false);
      }
    })();
  }, [ready]);

  return { employeesMinimal, loadingEmployeesMinimal, errorEmployeesMinimal };
}
